import styled from "styled-components";

import { windowWidth } from "@styles/global";

// Libraries
import { FormControl } from "@libraries/mui";

const FormContainer = styled.form`
  overflow-y: auto;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 7px;
  padding-bottom: 20px;

  @media (max-width: ${windowWidth.tablet}) {
    width: 100%;

    ::-webkit-scrollbar {
      width: 1px;
    }
  }

  .MuiAutocomplete-root {
    width: 440px;
    min-height: 65px;

    @media (max-width: ${windowWidth.tablet}) {
      width: 100%;
    }
  }
`;

const SelectItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;

  > :first-child {
    div {
      width: 22px;
      height: 22px;
    }
  }
`;

const CustomFormControl = styled(FormControl)`
  width: 0px !important;
`;

export { FormContainer, SelectItem, CustomFormControl };
